import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import '../LandingPage.css';

const LandingFooter = () => {
  const { t } = useLanguage();

  return (
    <footer className="landing-footer">
      <div className="landing-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>{t('appName')}</h3>
            <p>{t('landing.footerTagline')}</p>
          </div>
          <div className="footer-links">
            <Link to="/login">{t('auth.login')}</Link>
            <Link to="/register">{t('auth.register')}</Link>
            <Link to="/privacy-policy">{t('legal.privacyPolicy')}</Link>
            <Link to="/terms-and-conditions">{t('legal.termsAndConditions')}</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 {t('appName')}. {t('landing.allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;

